import { render } from "./logoMobile.svg?vue&type=template&id=40812c60?inline"
const script = {}

import exportComponent from "/home/petro/programming/Work/roman-choir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__